import styled from 'styled-components';

// The design's row is full width with a 6px bottom margin and no padding,
// holding the link against its right edge.
export const ForgotPasswordRow = styled.div`
  display: flex;
  justify-content: flex-end;

  width: 100%;
  margin-bottom: 16px;
  padding: 0;
`;

export const ForgotPasswordLink = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  margin-top: -8px;

  font-size: 12px;
  font-weight: 500;
  color: rgba(66, 46, 133, 0.8);
  text-decoration: none;

  transition: color 0.2s;

  &:hover {
    color: rgba(66, 46, 133, 0.95);
  }
`;
